import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "../i18n/langs";

Vue.use(VueI18n);

const licenseChat = 11;
const licenseCrawler = 12;
const licenseCodeNumbers = 13;
const licenseAutoVue = 14;

const itemBaseClassId = 101;
const changeBaseClassId = 104;
const manufactureBaseClassId = 105;
const manufacturePartBaseClassId = 106;
const userBaseClassId = 901;
const userGroupBaseClassId = 902;
const projectBaseClassId = 301;
const qualityBaseClassId = 401;
const qualityProblemReportClassId = 40101;
const qualityCAPAClassId = 40102;
const ppmTaskSubClassId = 3010104;

const itemBOMQty = 1003003;
const itemBOMMultilist01 = 1003078;
const itemBOMList02 = 1003034;
const itemBOMList01 = 1003033;

const userGroupRoles = 1092005;
const userGroupOwner = 1092006;

const projectP1Root = 1051014;
const projectP1Parent = 1051015;
const projectP1Status = 1051019;
const projectP1CreateFromTemplate = 1051052;

const attachmentFileName = 2010001;

const problemNumber = 4011002;
const qualityNumber = 4012001;

const listTypeSimple = 1;
const listTypeCascade = 2;
const listTypeDynamic = 3;
const listTypeCode = 4;
const listTypeSerialNumber = 5;
const listTypeVersionNumber = 6;
const listTypeReference = 7;

export const getTab = (id) => {
  const i18n = new VueI18n({
    locale: window.localStorage.getItem("lang"),
    messages,
    silentTranslationWarn: true,
  });

  const tabOther = [
    {
      name: i18n.t("message.title.titleBlock"),
      id: "titleblock_redline",
      objId: 1010101,
    },
    {
      name: "BOM",
      id: "Bom_redLine",
      objId: 1010102,
    },
    {
      name: i18n.t("message.title.manufacturer"),
      id: "manufacturer_redLine",
      objId: 1010105,
    },
    {
      // name: i18n.t("message.title.attachment"),
      name: i18n.t("message.title.itemAttachment"),
      id: "attachment_redLine",
      objId: 1010104,
    },
  ];
  const tabMCO = [
    {
      name: i18n.t("message.title.titleBlock"),
      id: "titleblock_redline",
      objId: 1010101,
    },
    {
      name: i18n.t("message.title.manufacturer"),
      id: "manufacturer_redLine",
      objId: 1010105,
    },
  ];
  const tabTechnology = [
    {
      name: i18n.t("message.title.titleBlock"),
      id: "titleblock_redline",
      objId: 1010101,
    },
    {
      name: "BOM",
      id: "Bom_redLine",
      objId: 1010103,
    },
    {
      name: i18n.t("message.title.attachment"),
      id: "attachment_redLine",
      objId: 1010104,
    },
  ];
  if (id == 10402) {
    return tabMCO;
  } else if (id == 10410) {
    return tabTechnology;
  } else {
    return tabOther;
  }
};

export const CACHE_COMPlIST = [
  // "/myAgent",
  // // "/classes",
  "/advancedSearch",
  // "/BOMCompare",
  // "/simpleSearch",
];

export const ROUTE_KEY_LIST = [
  "/users",
  "/privs",
  "/roles",
  "/autoNumbers",
  "/settingAPI",
  "/folderList",
];


export const LINK_LIST = [
  1003001, 1005001, 1006001, 1007007, 2000001, 1008001, 1009001, 1090001, 1096001, 1017001, 1013002, 1010002, 1015002, 1014002, 1095002, 1094002,
  1018001, 1093001, 1055001, 1054001, 4012001, 4011002,
  5013002, 5014001, 1025004, 5015001, 5011001, 5012007, 5021001, 5022001, 5016001, 5017001, 1024001,];

export const MULTI_BOM_LIST = [1010103, 1010109, 1010110, 1010111, 1010112, 1010113, 1010114,
  1010115, 1010116, 1010117, 1010118,]
export const PROJECTROUTE_LIST = ["/projectTitle", "/projectSchedule", "/projectTeam", "/projectScheduleComments", "/ProjectAttachment", "/projectDeliverable", "/projectHistory"]

export const CHANGE_FOR_MEDLINKET = {
  "pageOne": {
    "1004001": "编号自动生成",
    "1004008": 113,
    "1004003": 20000035,
    "classId": 10401
  },
  "pageTwo": {},
  "pageThree": {},
  "objectId": {
    "classId": 10401,
    // "subClassId": 20000035,
    "subClassId": 1040101,
    "id": ""
  }
};

export const ITEM_FOR_MEDLINKET_ATTACHMENT = {
  "classId": 10401,
  "subClassId": 20000035,
  "version": "",
  "currentStatus": 10145,
  "currentStatusType": 0,
  "nextStatus": 10146,
  "nextStatusType": 2,
  "workflowId": 113,
  "status": 10146,
  "approvers": [
    {
      "id": 164,
      "loginId": "XieJuan",
      "type": "1"
    }
  ],
  "observers": [],
  "comments": ""

};

export default {
  licenseChat,
  licenseCrawler,
  licenseCodeNumbers,
  licenseAutoVue,
  itemBaseClassId,
  changeBaseClassId,
  manufactureBaseClassId,
  manufacturePartBaseClassId,
  userBaseClassId,
  userGroupBaseClassId,
  projectBaseClassId,
  itemBOMQty,
  itemBOMMultilist01,
  itemBOMList02,
  itemBOMList01,
  userGroupRoles,
  userGroupOwner,
  projectP1Root,
  projectP1Parent,
  projectP1Status,
  projectP1CreateFromTemplate,
  attachmentFileName,
  listTypeSimple,
  listTypeCascade,
  listTypeDynamic,
  listTypeCode,
  listTypeSerialNumber,
  listTypeVersionNumber,
  listTypeReference,
  problemNumber,
  qualityNumber,
  qualityBaseClassId,
  qualityCAPAClassId,
  qualityProblemReportClassId,
  ppmTaskSubClassId,
};
